import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, styled, Typography, useMediaQuery, useTheme, } from "@mui/material";
import Grid from "@mui/material/Grid2";
import EventAuthFooter from "@ui/components/Footers/EventAuthFooter";
import { SwitchLanguage } from "@ui/components/language";
import { rowCenter } from "@ui/style/style";
import { useTranslation } from "react-i18next";
export const VideoBackground = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 4,
    objectFit: "cover",
    background: "linear-gradient(71.31deg, rgba(0, 36, 77, 0.9) 0.88%, rgba(0, 36, 77, 0.9) 98.28%)",
}));
export const ContentBoxContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    position: "relative",
    flex: 1,
    width: "100%",
    zIndex: 15,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(15),
    [theme.breakpoints.down(1200)]: {
        padding: theme.spacing(8),
        paddingTop: '96px'
    },
    [theme.breakpoints.between(1280, 1281)]: {
        paddingTop: 0,
    },
    "&:-webkit-scrollbar-thumb": {
        display: "none",
    },
    [theme.breakpoints.down(900)]: {
        padding: "clamp(16px, 4.1vw, 64px)",
        paddingBottom: 0,
        alignItems: "unset",
    },
    [theme.breakpoints.down(601)]: {
        paddingTop: 'clamp(16px, calc(221.71px - 34.29vw), 88px)',
    },
    paddingBottom: 0,
}));
const AuthWrapper = ({ children }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const isBelow1024 = useMediaQuery(theme.breakpoints.down(1025));
    const isBelow390 = useMediaQuery(theme.breakpoints.down(391));
    const isMediumHeight = useMediaQuery("(max-height:720px) and (min-width:900px) and (max-width:1280px)");
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    return (_jsxs(Box, { sx: {
            position: "relative",
            height: "100dvh",
            width: "100%",
            overflow: "hidden",
        }, children: [_jsx(Box, { sx: {
                    position: "absolute",
                    top: "120px",
                    left: "0",
                    zIndex: 6,
                    width: "100%",
                    height: "100%",
                    [theme.breakpoints.down(901)]: {
                        display: "none",
                    },
                }, className: "curve-image", children: _jsx("img", { src: "/assets/images/main-page.png", alt: "Background image", style: { width: "100%", height: "100%" } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: "88px",
                    [theme.breakpoints.up(901)]: {
                        display: "none",
                    },
                    left: "0",
                    zIndex: 6,
                    width: "100%",
                }, className: "curve-image", children: _jsx("img", { src: "/assets/images/curve-image-mobile.svg", alt: "Background image", style: { width: "100%", height: "100%" } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: isBelow390 ? "8px" : isBelow1024 ? "16px" : "24px",
                    right: isBelow390 ? "8px" : isBelow1024 ? "20px" : "48px",
                    zIndex: 16,
                }, children: _jsx(SwitchLanguage, { buttonProps: {
                        sx: {
                            borderRadius: 2,
                            backgroundColor: "white !important",
                            border: 0,
                            "&:hover": {
                                backgroundColor: "lightgray !important",
                                boxShadow: "none",
                            },
                            height: isBelow1024 ? 40 : 48,
                        },
                        style: {
                            background: "white",
                        },
                        className: "translation-button",
                    } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    zIndex: 5,
                    opacity: 1,
                    width: "100%",
                    height: "100%",
                }, className: "main-background-image", children: _jsx("img", { src: "/assets/images/MainBackground.png", alt: "Background image", style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center center",
                    } }) }), _jsxs("video", { width: "auto", autoPlay: true, loop: true, height: "auto", className: "background-video", playsInline: true, muted: true, style: {
                    position: "absolute",
                    top: 0,
                    zIndex: 5,
                    opacity: 0.1,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                }, children: [_jsx("source", { src: "https://euwvdkprdst01.blob.core.windows.net/prod/videos/background-video.mp4" }), "Your browser does not support the video tag."] }), _jsx(VideoBackground, {}), _jsxs(Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    minHeight: "100dvh",
                    height: "100%",
                    zIndex: 7,
                    overflow: "auto",
                    scrollbarWidth: "none" /* For Firefox */,
                    "&:-webkit-scrollbar-thumb": {
                        display: "none",
                    },
                }, className: "inner-container", children: [_jsx(ContentBoxContainer, { className: "content-box-container", children: _jsxs(Grid, { container: true, rowSpacing: isSmallScreen ? 2 : 5, alignItems: isMediumHeight ? "center" : "center", columnSpacing: isBelow390 ? "32px" : isBelow1024 ? "96px" : "122px", children: [_jsxs(Grid, { size: { xs: 12, sm: 12, md: 6 }, display: "flex", flexDirection: "column", alignItems: "center", sx: {
                                        "@media (min-width: 1024px)": {
                                            gap: 4,
                                            maxWidth: 488,
                                        },
                                        "@media (max-width: 1024px)": {
                                            gap: 3,
                                            maxWidth: 362,
                                        },
                                        [theme.breakpoints.down('md')]: {
                                            maxWidth: '100%',
                                        },
                                        "@media (max-width: 390px)": {
                                            gap: 2,
                                        },
                                    }, children: [_jsx(Box, { sx: { ...rowCenter }, children: _jsx(Box, { component: "img", src: "/assets/images/swd.png", sx: {
                                                    width: "auto",
                                                    height: { xs: 140, lg: "20svh" },
                                                    display: { xs: "block" },
                                                }, alt: "feature image" }) }), _jsxs(Box, { display: "flex", flexDirection: "column", sx: {
                                                "@media (min-width: 1024px)": {
                                                    gap: 4,
                                                },
                                                "@media (max-width: 1024px)": {
                                                    gap: 3,
                                                },
                                                "@media (max-width: 390px)": {
                                                    gap: 2,
                                                },
                                            }, children: [_jsxs(Typography, { fontSize: { xs: 28, lg: 40 }, fontFamily: "Formula1", fontWeight: 500, lineHeight: "100%", color: "#FFFFFF", textTransform: "uppercase", sx: {
                                                        [theme.breakpoints.between(1200, 1280)]: {
                                                            fontSize: 32,
                                                        },
                                                    }, children: [t("eventlogin.welcomeHeading1"), _jsx("br", {}), t("eventlogin.welcomeHeading2")] }), _jsxs(Box, { px: { xs: 1, md: 0 }, children: [_jsxs(Typography, { fontWeight: 400, variant: "subtitle1", textAlign: "center", color: "#FFFFFF", display: "block", children: [t("eventlogin.uniqueDay"), _jsx("span", { style: {
                                                                        color: "#00B6ED",
                                                                        marginLeft: "6px",
                                                                        marginRight: "6px",
                                                                        fontWeight: 500,
                                                                    }, children: t("eventlogin.dateAndTime") }), t("eventlogin.duringFormula")] }), _jsx(Typography, { sx: {
                                                                [theme.breakpoints.up(1024)]: {
                                                                    mt: 4,
                                                                },
                                                                [theme.breakpoints.down(1024)]: {
                                                                    mt: 3,
                                                                },
                                                                [theme.breakpoints.down(391)]: {
                                                                    mt: 2,
                                                                },
                                                            }, variant: "subtitle1", textAlign: "center", color: "#FFFFFF", fontWeight: 400, display: "block", children: t("eventlogin.welcomeSubHeading") })] })] })] }), _jsx(Grid, { maxWidth: { xs: "100%", md: 590 }, size: { xs: 12, sm: 12, md: 6 }, children: children })] }) }), _jsx(EventAuthFooter, { showCredits: true })] })] }));
};
export default AuthWrapper;
